// extracted by mini-css-extract-plugin
export var circle = "_eg-1";
export var exitConfirmationModal = "_eg-5";
export var iframe = "_eg-0";
export var offline = "_eg-3";
export var online = "_eg-2";
export var workstationSelectError = "_eg-4";